import { baseUrl } from "./config";
import { storageKey } from "./userProvider";
import * as action from "../actions/index";

const paymentUrl = "https://pay-dev.devari.com.br";

const paymentData = {
  currency: "BRL",
  capture: true,
  payment_type: "credit",
  description: "Webjob buying credits"
};

const token = "7637eb6f6af35099776aad1dc1f664c173420ce8";
const appId = "LA9QfH5n";

/* export async function createCard(payload) {
  const data = {
    ...payload,
    app_code: appId
  };
  try {
    const response = await fetch(`${paymentUrl}/api/v1/customer/token/`, {
      method: "post",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`
      }
    });

    if (!response.ok) {
      console.log(response);
      throw { message: "Não foi possível cadastrar o cartão" };
    }
    const result = await response.json();
    //console.log(result);

    return { error: false, result };
  } catch (error) {
    console.log(error);

    return { error: true, message: error.message };
  }
} */

export async function buyCredits(payload) {
  const data = {
    ...paymentData,
    ...payload
  };
  try {
    const response = await fetch(`${paymentUrl}/api/v1/checkout/`, {
      method: "post",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`
      }
    });

    if (!response.ok) {
      console.log(response);
      throw { message: "Não foi possível realizar o pagamento" };
    }
    const result = await response.json();
    console.log(result);

    return { error: false, result };
  } catch (error) {
    console.log(error);

    return { error: true, message: error.message };
  }
}

export const addCredits = (newAmount, userId, token) => async dispatch => {
  try {
    const response = await fetch(`${baseUrl}/users/${userId}`, {
      method: "PATCH",
      body: JSON.stringify({ credits: newAmount }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    if (!response.ok) {
      //console.warn(response);
      throw { message: "Não foi possível realizar esta ação" };
    }
    const result = await response.json();
    console.log(result);
    dispatch(
      action.setChangeUpdateSuccess("Perfil atualizado com sucesso.", {
        credits: newAmount
      })
    );
    setTimeout(() => dispatch(action.setChangeUpdateSuccess("", {})), 3000);
    localStorage.setItem(storageKey, JSON.stringify({ ...result, token }));
    return result;
  } catch (error) {
    console.log(error);
    return { error: true };
  }
};

export const makePayment = async payload => {
  const data = {
    ...paymentData,
    app_code: appId,
    ...payload
  };
  try {
    const response = await fetch(`${paymentUrl}/api/v1/token/checkout/`, {
      method: "post",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`
      }
    });

    if (!response.ok) {
      console.log(response);
      throw { message: "Não foi possível realizar o pagamento" };
    }
    const result = await response.json();
    console.log(result);

    return { error: false, result };
  } catch (error) {
    console.log(error);

    return { error: true, message: error.message };
  }
};

//devaripay pagamentos efetuados
export const getPaymentsMade = async email => {
  try {
    const response = await fetch(
      `${paymentUrl}/api/v1/transaction/?seller__app=${appId}&email=${email}`,
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`
        }
      }
    );

    if (!response.ok) {
      console.log(response);
      throw { message: "Ocorreu um problema ao listar as transações" };
    }
    const result = await response.json();
    //console.log(result);

    return { error: false, result };
  } catch (error) {
    console.log(error);

    return { error: true, message: error.message };
  }
};

//backend solicitar saque
export const requestWithdraw = async (userId, value, token) => {
  const data = {
    userId,
    value
  };
  try {
    const response = await fetch(`${baseUrl}/withdraws/`, {
      method: "post",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    if (!response.ok) {
      console.log(response);
      throw { message: "Não foi possível realizar o pagamento" };
    }
    const result = await response.json();
    console.log(result);

    return { error: false, result };
  } catch (error) {
    console.log(error);

    return { error: true, message: error.message };
  }
};

//historico de recebidos
export const getPaymentsReceived = async (userId, token) => {
  try {
    const response = await fetch(`${baseUrl}/withdraws/user/${userId}`, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    if (!response.ok) {
      console.log(response);
      throw { message: "Não foi possível buscar seus saques" };
    }
    const result = await response.json();
    console.log(result);

    return { error: false, result };
  } catch (error) {
    console.log(error);

    return { error: true, message: error.message };
  }
};

export const createCustomer = async (
  first_name,
  last_name,
  email,
  taxpayer
) => {
  const data = {
    first_name,
    last_name,
    email,
    taxpayer,
    app_code: appId
  };

  console.log(data);

  try {
    const response = await fetch(`${paymentUrl}/api/v1/customer/`, {
      method: "post",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`
      }
    });

    if (!response.ok) {
      console.log(response);
      throw { message: "Não foi possível cadastrar o customer" };
    }
    const result = await response.json();
    //console.log(result);

    return { error: false, result };
  } catch (error) {
    console.log(error);

    return { error: true, message: error.message };
  }
};

export const createCard = async (
  holder_name,
  email,
  exp_month,
  exp_year,
  number,
  cvc
) => {
  const data = {
    holder_name,
    email,
    exp_month,
    exp_year,
    number,
    cvc,
    app_code: appId
  };
  try {
    const response = await fetch(`${paymentUrl}/api/v1/card/`, {
      method: "post",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`
      }
    });

    if (!response.ok) {
      console.log(response);
      throw { message: "Não foi possível cadastrar o cartão" };
    }
    const result = await response.json();
    //console.log(result);

    return { error: false, result };
  } catch (error) {
    console.log(error);

    return { error: true, message: error.message };
  }
};

export const associateCard = async (email, card) => {
  const data = {
    email,
    card,
    app_code: appId
  };
  try {
    const response = await fetch(`${paymentUrl}/api/v1/association/`, {
      method: "post",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`
      }
    });

    if (!response.ok) {
      console.log(response);
      throw { message: "Não foi possível associar o cartão" };
    }
    const result = await response.json();
    //console.log(result);

    return { error: false, result };
  } catch (error) {
    console.log(error);

    return { error: true, message: error.message };
  }
};

export const getCard = async email => {
  try {
    const response = await fetch(
      `${paymentUrl}/api/v1/card/list/?email=${email}&app_code=${appId}`,
      {
        method: "get",
        headers: {
          Authorization: `Token ${token}`
        }
      }
    );

    if (!response.ok) {
      console.log(response);
      throw { message: "Não foi possível associar o cartão" };
    }
    const result = await response.json();
    //console.log(result);

    return { error: false, result };
  } catch (error) {
    console.log(error);

    return { error: true, message: error.message };
  }
};
